import { useLocalStorage } from './useLocalStorage';

export const useLocalStorageToggle = (
  key: string,
  defaultValue: boolean
): [boolean, () => void] => {
  const [value, setValue] = useLocalStorage(key, defaultValue);
  const toggleValue = () => setValue(!value);

  return [value, toggleValue];
};
